import { Order } from "src/app/types/orders/order";
import { UpsertOrderForm } from "../../components";
import {
    useContentTypeOptions,
    usePlatformOptions,
    useProofreaderOptions,
    useRDOptions,
    useSiteListByManagerOptions,
    useThematicsOptions,
    useWritingTypeOptions,
} from "src/app/hooks";
import useWritersOptions from "src/app/hooks/useWritersOptions/useWritersOptions";
export interface IUpsertOrderFormBodyContainer {
    entity?: Order;
}
const UpsertOrderFormContainer = (props: IUpsertOrderFormBodyContainer) => {
    const { entity } = props;

    const { platformOptions } = usePlatformOptions();
    const { writersOptions } = useWritersOptions();
    const { writingTypeOptions } = useWritingTypeOptions();
    const { contentTypeOptions } = useContentTypeOptions();
    const { proofreaderOptions } = useProofreaderOptions();
    const { siteListByManagerOptions } = useSiteListByManagerOptions();
    const { thematicsOptions } = useThematicsOptions();
    const { RDOptions } = useRDOptions();

    return (
        <UpsertOrderForm
            manager={entity?.manager}
            contentTypeOptions={contentTypeOptions}
            writingTypeOptions={writingTypeOptions}
            moneySiteOptions={siteListByManagerOptions}
            RDOptions={RDOptions}
            thematicOptions={thematicsOptions}
            proofreaderOptions={proofreaderOptions}
            writerOptions={writersOptions}
            platformOptions={platformOptions}
        />
    );
};

export default UpsertOrderFormContainer;
